module.exports = "/assets/309a8afca381de5dfe04edf573e31af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XR.png
// module id = 2006
// module chunks = 0